export enum MfeEventType {
  OrchestratorRoutingEvent = 'OrchestratorRoutingEvent'
}

export interface MfeEvent {
  type: MfeEventType;
  listener: (e: CustomEvent) => void;
}
